import React from 'react';
import ChartistGraph from 'react-chartist';
import { MyContext } from '../context';
import UffrideCharge from '../modal/UffrideCharge';
export default class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    this.detailModal = React.createRef();
  }
  showModal(modal, config) {
    modal.current.showModal();
    modal.current.setState({
      show: true,
      config
    });
    this.setState({
      config
    })
  }
  render() {
    return (
      <MyContext.Consumer>
        {state => {
          if (state) {
            var data = {
              series: [state.config.stripe, 100 - state.config.commission - state.config.stripe, state.config.commission],
              labels: ['Stripe', 'Driver Earnings', 'Uffride Charge']
            };
            var options = {
              donut: true,
              donutWidth: 17,
              showLabel: false
            };
            var type = 'Pie'
            var listener = {
              draw: function (data) {
                if (data.type === 'slice') {
                  var pathLength = data.element._node.getTotalLength();
                  data.element.attr({
                    'stroke-dasharray': pathLength + 'px ' + pathLength + 'px'
                  });
                  var animationDefinition = {
                    'stroke-dashoffset': {
                      id: 'anim' + data.index,
                      dur: 1000,
                      from: -pathLength + 'px',
                      to: '0px',
                      easing: 'easeOutQuint',
                      fill: 'freeze'
                    }
                  };
                  if (data.index !== 0) {
                    animationDefinition['stroke-dashoffset'].begin = 'anim' + (data.index - 1) + '.end';
                  }
                  data.element.attr({
                    'stroke-dashoffset': -pathLength + 'px',
                    // 'stroke': data.meta.color
                  });
                  // See http://gionkunz.github.io/chartist-js/api-documentation.html#chartistsvg-function-animate
                  data.element.animate(animationDefinition, false);
                }
              },
            }
            return (
              <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver-desktop m-grid--desktop 	m-container m-container--responsive m-container--xxl m-page__container m-body">
                <div className="m-grid__item m-grid__item--fluid m-wrapper">
                  <div className="m-subheader ">
                    <div className="d-flex align-items-center">
                      <div className="mr-auto">
                        {/* <h3 className="m-subheader__title ">Dashboard</h3> */}
                      </div>
                    </div>
                  </div>
                  <div className="m-content">
                    <div className="m-portlet">
                      <div className="m-portlet__body  m-portlet__body--no-padding">
                        <div className="row m-row--no-padding m-row--col-separator-xl">
                          <div className="col-xl-4">
                            <div className="m-widget1">
                              <h2 className="section-header">Users</h2>
                              {this.widget1__item("Total Drivers", "Valid Registerd Drivers", state.totalDriver - state.notVerified, `m--font-focus`)}
                              {this.widget1__item("Active Drivers", "Online Drivers", state.activeDriver, `m--font-focus`)}
                              {this.widget1__item("Driver Verification", "Verification Requests", state.notVerified, `m--font-danger`)}
                              {this.widget1__item("Total Rides", "Registerd Users", state.totalUser, `m--font-info`)}
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="m-widget1">
                              <h2 className="section-header">Earning</h2>
                              {this.widget1__item("Total Rides", "Total Completed Rides", state.totalTrip, `m--font-focus`)}
                              {this.widget1__item("Total Earnings", "Total Rides Earnings", `$ ${Number(state.totalEarning).toFixed(2)}`, `m--font-focus`)}
                              <div className="m-widget14__header mt-2">
                                <span className="m-widget14__desc">Total Ride, Driver and Users</span>
                              </div>
                              <div className="m-widget14">
                                <div className="row  align-items-center">
                                  <div className="col">
                                    <ChartistGraph
                                      data={data}
                                      options={options}
                                      type={type}
                                      // listener={listener}
                                      className="m-widget14__chart" style={{ height: " 160px" }}>
                                      <div className="m-widget14__stat"></div>
                                    </ChartistGraph>
                                  </div>
                                  <div className="col">
                                    <div className="m-widget14__legends">
                                      <div className="m-widget14__legend">
                                        <span className="m-widget14__legend-bullet m--bg-accent"></span>
                                        <span className="m-widget14__legend-text">{data.series[0]}% Stripe Fee</span>
                                      </div>
                                      <div className="m-widget14__legend">
                                        <span className="m-widget14__legend-bullet m--bg-warning"></span>
                                        <span className="m-widget14__legend-text">{data.series[1]}% Driver Earnings</span>
                                      </div>
                                      <div className="m-widget14__legend">
                                        <span className="m-widget14__legend-bullet m--bg-brand"></span>
                                        <span className="m-widget14__legend-text">{data.series[2]}% Uffride Service Fee
                                        <a onClick={e => { this.showModal(this.detailModal, state.config) }} className="btn text-underline text-sm">Update</a>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4">
                            <div className="m-widget1">
                              <h2 className="section-header">Rides</h2>
                              {this.widget1__item("Ride Requests", "Total Ride Requests", state.requstTrip, "m--font-danger")}
                              {this.widget1__item("Rides", "On Going Rides", state.onGoing, "m--font-info")}
                              {this.widget1__item("Completed Rides", "Total Completed Rides", state.completeTrip, "m--font-info")}
                              {this.widget1__item("Cancelled Rides", "Total Cancelled Rides", state.cancelledTrip, "m--font-info")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <UffrideCharge ref={this.detailModal} id="uffrideModal" />
              </div >
            )
          }
        }}
      </MyContext.Consumer>
    )
  }
  // fckgaphnjokfyncf
    widget1__item(title, desc, value, style) {
    return (
      <div className="m-widget1__item">
        <div className="row m-row--no-padding align-items-center">
          <div className="col">
            <h3 className="m-widget1__title">{title}</h3>
            <span className="m-widget1__desc">{desc}</span>
          </div>
          <div className="col m--align-right">
            <span className={"m-widget1__number " + style}>{value}</span>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/include/Dashboard.js